import React, { useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { useMain } from '../Hook/Main';
export let refBody = null;
function Index({ children, nav = true }) {
    refBody = useRef()
    const { data, setData } = useMain();
    const { categoreis } = data;
    const navigate = useNavigate();
    return (
        <div className="container-fluid">
            <div className="row justify-content-center">
                <div id='PageMain' className={`${nav ? " pb-5 " : ""} col-lg-4 px-0 position-relative`} ref={refBody} style={{ overflowX: 'hidden', height: '100vh' }}>
                    {children}
                    {nav &&
                        <div className='tab-bottom-navigate col-lg-4'>
                            <Link to="/" className='item-tab-bottom'>
                                <i className='fas fa-home'></i>
                                <a>آگهی ها</a>
                            </Link>
                            <a onClick={() => {
                                if (categoreis) {
                                    setData('category', categoreis[0], null, true);
                                    setData('filter', { category_id: categoreis[0].id }, 'data', true)
                                    navigate('/ProductList', { state: { category: categoreis[0] } })
                                }
                            }} className='item-tab-bottom'>
                                <i className='fas fa-list'></i>
                                <a className='link-bg'>گمشده /پیدا شده</a>
                            </a>
                            <Link to="/AddItem" className='item-tab-bottom'>
                                <i className='fas fa-plus'></i>
                                <a>ثبت آگهی جدید</a>
                            </Link>
                            <Link to="/Messages" className='item-tab-bottom'>
                                <i className='fas fa-comment'></i>
                                <a>چت</a>
                            </Link>
                            <Link to="/UserProfile" className='item-tab-bottom'>
                                <i className='fas fa-user'></i>
                                <a>پروفایل</a>
                            </Link>
                        </div>
                    }
                </div>
            </div>
            {window.screen.width > 1000 ? <>
                <a style={{ position: "fixed", right: 0, bottom: 0 }} referrerPolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=291728&amp;Code=yKYpZev3aV66bohhRRGM">
                    <img referrerPolicy="origin" src="https://Trustseal.eNamad.ir/logo.aspx?id=291728&amp;Code=yKYpZev3aV66bohhRRGM" alt="" style={{ cursor: "pointer", width: 100, height: 100 }} id="yKYpZev3aV66bohhRRGM" />
                </a>
                <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQwIiBoZWlnaHQ9IjM2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCTxwYXRoIGQ9Im0xMjAgMjQzbDk0LTU0IDAtMTA5IC05NCA1NCAwIDEwOSAwIDB6IiBmaWxsPSIjODA4Mjg1Ii8+Cgk8cGF0aCBkPSJtMTIwIDI1NGwtMTAzLTYwIDAtMTE5IDEwMy02MCAxMDMgNjAgMCAxMTkgLTEwMyA2MHoiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDo1O3N0cm9rZTojMDBhZWVmIi8+Cgk8cGF0aCBkPSJtMjE0IDgwbC05NC01NCAtOTQgNTQgOTQgNTQgOTQtNTR6IiBmaWxsPSIjMDBhZWVmIi8+Cgk8cGF0aCBkPSJtMjYgODBsMCAxMDkgOTQgNTQgMC0xMDkgLTk0LTU0IDAgMHoiIGZpbGw9IiM1ODU5NWIiLz4KCTxwYXRoIGQ9Im0xMjAgMTU3bDQ3LTI3IDAtMjMgLTQ3LTI3IC00NyAyNyAwIDU0IDQ3IDI3IDQ3LTI3IiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MTU7c3Ryb2tlOiNmZmYiLz4KCTx0ZXh0IHg9IjE1IiB5PSIzMDAiIGZvbnQtc2l6ZT0iMjVweCIgZm9udC1mYW1pbHk9IidCIFlla2FuJyIgc3R5bGU9ImZpbGw6IzI5Mjk1Mjtmb250LXdlaWdodDpib2xkIj7Yudi22Ygg2KfYqtit2KfYr9uM2Ycg2qnYtNmI2LHbjDwvdGV4dD4KCTx0ZXh0IHg9IjgiIHk9IjM0MyIgZm9udC1zaXplPSIyNXB4IiBmb250LWZhbWlseT0iJ0IgWWVrYW4nIiBzdHlsZT0iZmlsbDojMjkyOTUyO2ZvbnQtd2VpZ2h0OmJvbGQiPtqp2LPYqCDZiCDaqdin2LHZh9in24wg2YXYrNin2LLbjDwvdGV4dD4KPC9zdmc+ " alt="" onClick={() => {
                    window.open('https://ecunion.ir/verify/boukanagahi.ir?token=381418962f8e3a9c7897', 'Popup', 'toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30')
                }} style={{ position: "fixed", right: 110, bottom: 0, cursor: "pointer", width: "96px", height: " 144px" }} />
            </> : null}
        </div>
    )
}

export default Index